<template>
  <div class="ad">
    <img class="ad__image" :src="image">
    <div class="ad__content">
      <h1 class="ad-title">{{getResource('AdvertisementHeader')}}</h1>
      <p class="ad-leading">{{getResource('AdvertisementContent')}}</p>
      <a href="#" class="simple-button" v-on:click.prevent="navigateToKiosk()">{{getResource('GetItNow')}}</a>
    </div>
  </div>
</template>

<script>
import { getResource } from "../../vuex/helpers";

export default {
  data: function () {
    return {
      image: "static/img/kiosk.jpg"
    };
  },
  vuex: {
    actions: { getResource }
  },
  methods: {
    navigateToKiosk (item) {
      this.$router.go("/documents/27");
    }
  }
};
</script>


<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .ad{
    @include clear-fix;
    background: $brown_light;

    &__image{
      float: left;
      width: 66%;
    }

    &__content{
      float: left;
      color: $white;
      padding: 52px 48px 40px;
      width: 34%;
      box-sizing: border-box;
    }
  }

  .ad-title{
    font-size: 36px;
    line-height: 40px;
    margin: 0px 0px 40px;
    font-weight: normal;
  }

  .ad-leading{
    line-height: 24px;
    height: 120px;
    overflow: hidden;
    *{
      background: none !important;
      color: $white !important;
      text-align: left !important;
      font-size: 16px !important;
      margin: 0px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// HomeNewsAd.vue?6679d4a4